import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import MarketCommonApi from '../../../API/market/common-api';
import { Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { Select } from '../../../components/Basic/Inputs';
import { TYPE_BUTTONS } from '../../../constans';
import MarketsUpdateTable from './Table';

const MARKETS_ALL = ['Ozon', 'Wildberries', 'ЯндексМаркет'];
const STATE = ['Остатки', 'Цена'];

function MarketsUpdateStatusPage() {
  const [state, setState] = useState(STATE[0]);
  const [providers, setProviders] = useState([]);
  const allProviders = useSelector((store) => store.providers);
  const [market, setMarket] = useState(MARKETS_ALL[0]);
  const [data, setData] = useState([]);

  // список поставщиков
  useEffect(() => {
    const p = allProviders.filter((item) => !item['hide']);
    if (p.length > 0) {
      setProviders(p);
    }
  }, [allProviders]);

  let updateStatuses = () => {
    MarketCommonApi.getShopsInfo({})
      .then((r) => {
        setData(r.shopsInfo);
      });
  };

  useEffect(() => {
    updateStatuses();
  }, []);

  return (
    <Content>
      <WhiteBlock title="Площадка" title_bold={market} style={{ minWidth: '500px' }}>
        <Row style={{ alignItems: 'flex-end', marginBottom: '10px' }}>
          <Select list={MARKETS_ALL} select={market} label="Площадка" width={'150px'} onSelect={(m) => setMarket(m)} />
          <Button
            style={{ marginLeft: '15px', marginRight: '15px' }}
            type={TYPE_BUTTONS.WHITE}
            onClick={updateStatuses}
          >
            Обновить данные
          </Button>
        </Row>
      </WhiteBlock>
      <MarketsUpdateTable
        providers={providers}
        market={market}
        state={state}
        data={data}
        updateStatuses={updateStatuses}
      />
    </Content>
  );
}

export default MarketsUpdateStatusPage;
